document.addEventListener("DOMContentLoaded", function() {
  openExternalLinksInNewTabs();
  cartCountsAddClass();
  // updateUnavailableColorSwatches(); 
  // resetFilters();
  italicizeFabricsFilter();
  allColorsMenuItem();
  handleKlaviyoForms();
  translateBrowserValidation();
  hideShowCaptureForms();
  drawerOverlayFunctionality();
  initializeYotpo();
  hoverCardFunctionality();
  gsapAccordion();
  initCountDownTimers();
  scrollToFooterOnNewsletterSubscribe();
  mobileMenuAccordion();
  megaMenuMechanism();
  giftOrderCheckboxMechanism();
}); 

// alert('hello')

document.addEventListener('shopify:section:load', () => {
  hoverCardFunctionality();
});

// #### Begin Calling Fernando's new functions
// document.addEventListener('filters-removed', (e) => {
//     initCountDownTimers();
//   });

//   document.addEventListener('filters-applied', (e) => {
//     initCountDownTimers();
//   });

document.addEventListener('product-grid-loaded', (e) => {
  initCountDownTimers();
});


const defaultFormErrorMessage = 'Vous avez déjà demandé à recevoir une notification pour cet article.';
const defaultFormSuccessMessage = 'Merci, bien reçu !';

function openExternalLinksInNewTabs() {
  const links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    const link = links[i];
    if ((link.protocol === 'http:' || link.protocol === 'https:' ) && link.hostname !== window.location.hostname) {
      link.target = '_blank';
      link.rel = 'noreferrer noopener';
    }
  }
}

function updateUnavailableColorSwatches() {
  let colorSwatches = document.querySelectorAll('.product-item_color-swatch');
  
  colorSwatches.forEach((swatch)=>{ 
    let unavailableSwatch = swatch.querySelector('.product-item_color-swatch-na');
    if (unavailableSwatch != null) {
      swatch.style.opacity = '30%';
    }
  }) 
}   

/* 
function resetFilters() {
  let clearFiltersButton = document.querySelector('[data-clear-filters]');
  clearFiltersButton.addEventListener('click', () => {
    document.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
      input.parentElement.click();
    })
  })
} 
*/

function italicizeFabricsFilter() {
  let filterBlocks = document.querySelectorAll('.filter-menu_block.text-style-serif');
  
  filterBlocks.forEach((filterBlock) => {
    if (filterBlock) {
      let dataParamElement = filterBlock?.querySelector('label')
      let dataParamAttribute = dataParamElement?.getAttribute('data-param');
      
      if (dataParamAttribute?.includes('fabric')) {
        filterBlock.classList.add('text-style-serif-italic');
      }
    }
  })
}



function extractCollectionHandle(link) {
  let parts = link.split('/');
  let handle = parts[2];
  return handle;
}

// Function to fetch all products in a collection and get the total count
async function fetchAllProducts(handle) {
  let products = [];
  let page = 1;
  
  while (true) {
    // Fetch products in the collection
    const response = await fetch(`/collections/${handle}/products.json?page=${page}`);
    const data = await response.json();
    
    // Add fetched products to array
    products.push(...data.products);
    
    // Check if there are more products
    if (!data.products.length) {
      break;
    }
    page++;
  }
  return products;
}

// Function to get total product count
async function getTotalProductCount(handle) {
  const products = await fetchAllProducts(handle);
  return products.length;
} 

window.Udesly = window.Udesly || [];

window.Udesly.push(customFunctions)

let eventAdded = false;

function customFunctions() {
  window.Udesly.on('cart-updated', cartQuantityButtons);
  window.Udesly.on('error', handleCartErrorGlobally);
  // window.Udesly.on('cart-updated', updateLineItemPropertiesInCart);
  // here I can add the other functions based on other events as needed?
}

// create lastmoddedinput global variable
let lastModifiedInput = null;

// Function to update last modified input
function updateLastModifiedInput(e) {
  if (e.target.tagName === 'INPUT') {
    lastModifiedInput = e.target;
  }
}

// Attach the function to listen for change events on the cart form
const cartForm = document.querySelector('[data-node-type="commerce-cart-form"]');
if (cartForm) {
  cartForm.addEventListener('change', updateLastModifiedInput);
}

function handleCartErrorGlobally(e) {
  const statusCode = e.statusCode;
  const shopifyErrorMessage = e.error?.message;
  const udeslyErrorMessage = e.error;
  const addToCartErrorelements = document.querySelectorAll('[data-node-type="commerce-add-to-cart-error"]');
  const customErrorMessage = "Dernières pièces disponibles";
  
  console.log('Status Code:', statusCode);
  console.log('Error Message:', shopifyErrorMessage);
  
  if(shopifyErrorMessage || udeslyErrorMessage) {
    if (lastModifiedInput) {
      const errorMessageElement = lastModifiedInput.closest('[data-node-type="cart-item"]').querySelector('[data-cart-error-msg]');
      
      errorMessageElement.style.display = "block";
      setTimeout(() => {
        errorMessageElement.style.display = "none";
        window.Udesly.dispatch('cart-should-be-updated');
      }, 1500)
    }
    
    addToCartErrorelements.forEach(element => {
      element.textContent = customErrorMessage;
    });
  }
}


function cartQuantityButtons() { 
  
  
  let ajaxCartWrapper = document.querySelector('[data-node-type="commerce-cart-container-wrapper"]');
  let cartPageWrapper = document.querySelector('.cart-list');
  
  
  function incrementDecrement(e) {
    // Check if the target of the event is the plus button or any child element inside it
    var plusButton = e.target.closest('[data-qty-plus]');
    if (plusButton) {
      // Get the corresponding quantity input
      var quantityInput = plusButton.parentNode.querySelector('.cart-item_quantity-value input');
      
      // Increment the value of the quantity input
      quantityInput.value++;
      
      // Update the last modified input
      lastModifiedInput = quantityInput;
      
      // Dispatch a change event on the quantity input
      quantityInput.dispatchEvent(new Event('change', {bubbles: true}));
    }
    
    // Check if the target of the event is the minus button or any child element inside it
    var minusButton = e.target.closest('[data-qty-minus]');
    if (minusButton) {
      // Get the corresponding quantity input
      var quantityInput = minusButton.parentNode.querySelector('.cart-item_quantity-value input');
      // Decrement the value of the quantity input if it's greater than or equal to 1
      if (quantityInput.value > 1) {
        quantityInput.value--;
        
        // Update the last modified input
        lastModifiedInput = quantityInput;
        
        // Dispatch a change event on the quantity input
        quantityInput.dispatchEvent(new Event('change', {bubbles: true}));
      }
    } 
  } 
  
  if(!eventAdded) {
    if (ajaxCartWrapper != null && ajaxCartWrapper != undefined) {
      ajaxCartWrapper.addEventListener('click', incrementDecrement);
    }
    
    if (cartPageWrapper != null && cartPageWrapper != undefined) {
      cartPageWrapper.addEventListener('click', incrementDecrement);
    }
    eventAdded = true;
  }
}  



function updateLineItemPropertiesInCart() {
  let cartOptionListItems = document.querySelectorAll('[data-node-type="cart-option-list-item"]');
  let cartItems = document.querySelectorAll('[data-node-type="cart-item"]');
  
  cartItems.forEach((cartItem) => {
    let cartOptionListItemLabels = cartItem.querySelectorAll('[data-node-type="cart-option-list-item-label"]');
    let isPreorder = false;
    let isInStock = false;
    
    let itemPropKey = cartItem.querySelector('[data-item-prop-key]');
    let itemPropValue = cartItem.querySelector('[data-item-prop-value]');
    
    let webflowLabelTextContent = '';
    let webflowValueTextContent = '';
    
    cartOptionListItemLabels.forEach((label) => {
      if (label.textContent.includes('order')) {
        alert('it\'s preorder!')
        webflowLabelTextContent = label.textContent;
        webflowValueTextContent = label.nextElementSibling.textContent;
        isPreorder = true;
      } else if (label.textContent.includes('stock')) {
        alert('it\'s stock!')
        webflowLabelTextContent = label.textContent;
        webflowValueTextContent = label.nextElementSibling.textContent;
        isInStock = true;
      }
    });
    
    if (isPreorder || isInStock) {
      itemPropKey.textContent = webflowLabelTextContent;
      itemPropValue.textContent = webflowValueTextContent;
    }
  })
}

function allColorsMenuItem() {
  let allColorsLinks = document.querySelectorAll('[data-color-list]');
  allColorsLinks.forEach(link => {
    const allColorsLinkColorListBefore = link.dataset.colorList.replaceAll("'", '"');
    const allColorsLinkColorList = JSON.parse(allColorsLinkColorListBefore);
    const allColorsLinkLetters = link.querySelectorAll('span');
    
    allColorsLinkLetters.forEach((letter, letter_index) => {
      allColorsLinkColorList.forEach((colorCode, color_index) => {
        if (color_index === letter_index) {
          letter.style.color = `${colorCode}`;
        }
      });
    });
  });
}    

function initCountDownTimers() {
  
  const path = window.location.pathname;
  let pageType;
  
  
  if (path.includes('collections') && path.includes('products')) {
    pageType = 'productPage';
  } else if (path.includes('products') && path.includes('collections') === false) {
    pageType = 'productPage';
  } else if (path.includes('collections') && path.includes('products') === false) {
    pageType = 'collectionPage';
  }
  
  
  let countDownEndMessage;
  if (pageType === 'productPage') {
    countDownEndMessage = "Ce produit est lancé ! Pour commander, recharger la page !"
  } else if (pageType === 'collectionPage') {
    countDownEndMessage = "Cette collection est lancé ! Pour commander, recharger la page !"
  }
  // Get all elements with the "data-countdown" attribute
  var countDownElements = document.querySelectorAll('[data-countdown]');
  
  if (countDownElements != null && countDownElements != undefined) {
    countDownElements.forEach(countDownElement => {
      // Get the value of the "data-countdown" attribute
      var countDownType = countDownElement.getAttribute('data-countdown');
      var countDownDateValue = countDownElement.getAttribute('data-countdown-date');
      
      // Get the corresponding date/time from the variables in France timezone
      var countDownDate = new Date(countDownDateValue);
      // console.log('countDownDate:', countDownDate);
      
      // Update the count down every 1 second
      var x = setInterval(() => {
        // Get today's date and time in France timezone
        var now = new Date();
        // console.log('now:', now);
        var nowParisTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
        // console.log('nowParisTime:', nowParisTime);
        
        // Find the distance between now and the count down date
        var distance = countDownDate - nowParisTime;
        // console.log('distance:', distance);
        
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        if (hours < 10) {
          hours = "0" + hours;
        }
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        
        // Output the result in the current element
        if (days > 0) {
          countDownElement.innerHTML = days + " jours " + hours + ":" + minutes + ":" + seconds;
        } else {
          countDownElement.innerHTML = hours + ":" + minutes + ":" + seconds;
        }
        
        // If the count down is over, write some text
        if (distance < 0) {
          clearInterval(x);
          // console.log('countdown element:', countDownElement);
          countDownElement.parentElement.innerHTML = countDownEndMessage;
        }
      }, 1000);
    });
  }
}






function cartCountsAddClass() {
  // add the WF class that makes the product count dynamic to the second count (inside the cart)
  let cartCounts = document.querySelectorAll('[data-cart-count]');
  
  if (cartCounts != null && cartCounts != undefined) {
    cartCounts.forEach(element => {
      element.classList.add('w-commerce-commercecartopenlinkcount');
    });
  }
}


function captureKlaviyoEmail(listID, email, formElement) {
  const url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
  const data = new URLSearchParams({
    g: listID,
    email: email,
  }).toString();
  
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'cache-control': 'no-cache',
    },
    body: data,
  };
  
  fetch(url, options)
  .then((response) => {
    if (response.status === 200) {
      return response.json()
    } else if (response.status === 400) {
      throw new Error('400 BAD REQUEST: The email address used already exists in Klaviyo.')
    } else if (response.status === 405) {
      throw new Error('405 METHOD NOT ALLOWED: Required fields are missing from the POST request.')
    }
  })
  .then((response) => {
    if (response.success === false) {
      console.error('Klaviyo error:', response.errors[0]);
    } else if (response.success === true) {
      if (response.data.is_subscribed === false) {
        console.log('Klaviyo: customer succesfully subscribed to the list!');
        resetWebflowForm(formElement, 'success');
        console.log('Full response:', response);
      } else if (response.data.is_subscribed === true) {
        console.error('Customer is already subscribed to this Klaviyo list!');
        resetWebflowForm(formElement, 'error', "Vous êtes déjà inscrit à cette liste.");
      }
    }
  })
  .catch((error) => {
    console.error(error);
  });
  
}

function resetWebflowForm(form, status, statusMessage) {
  let customerEmail = form.querySelector('input[type="email"]');
  let formSuccessState = form.parentElement.querySelector('.w-form-done');
  let formErrorState = form.parentElement.querySelector('.w-form-fail');
  let closeBackInStockForms = form.closest('.product_notify-me-box')?.querySelector('[data-close-notify-form]');
  
  
  if (status == 'error') {
    if (statusMessage) {
      formErrorState.firstElementChild.textContent = statusMessage;
    } else {
      formErrorState.firstElementChild.textContent = defaultFormErrorMessage;
    }
    formErrorState.style.display = "block";
    customerEmail.value = '';
    setTimeout(() => {
      closeBackInStockForms?.click();
      formErrorState.style.display = "none";
    }, 3500);
  } else if (status == 'success') {
    
    if (statusMessage) {
      formSuccessState.firstElementChild.textContent = statusMessage;
    } else {
      formSuccessState.firstElementChild.textContent = defaultFormSuccessMessage;
    }
    form.style.display = "none";
    formSuccessState.style.display = "block";
    customerEmail.value = '';
    
    setTimeout(() => {
      closeBackInStockForms?.click();
      form.style.display = "flex";
      formSuccessState.style.display = "none";
      formErrorState.style.display = "none";
    }, 3500);
    
  }
  setTimeout(() => {
    closeBackInStockForms?.click();
  }, 3500);
}

function handleKlaviyoForms() {
  let klaviyoForms = document.querySelectorAll('[data-klaviyo-form]');
  
  if (!klaviyoForms) return;
  
  klaviyoForms.forEach(klaviyoForm => {
    klaviyoForm.addEventListener('submit', (e) => {
      e.preventDefault();
      let customerEmail = klaviyoForm.querySelector('input[type="email"]').value;
      let listID = klaviyoForm.querySelector('input[type="hidden"]').value;
      
      if (!customerEmail) return;
      // Call capture function from global script
      captureKlaviyoEmail(listID, customerEmail, klaviyoForm)
    })
  });
}

function hideShowCaptureForms() {
  let triggerButtons = document.querySelectorAll('[data-show-form]');
  let forms = document.querySelectorAll('[data-capture-form]');
  let closeButtons = document.querySelectorAll('[data-close-notify-form]');
  
  
  triggerButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      forms.forEach(form => {
        
        if (button.getAttribute('data-show-form') == form.getAttribute('data-capture-form')) {
          form.closest('[data-capture-form-wrap]').style.display = "block";
          console.log('works')
        } else {
          console.log('not found')
        }
      });
    })
  });
  
  closeButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      forms.forEach(form => {
        form.closest('[data-capture-form-wrap]').style.display = "none";
      });
    })
  });
}

function translateBrowserValidation() {
  const requiredFields = document.querySelectorAll('[required]');
  for (var i = 0; i < requiredFields.length; i++) {
    requiredFields[i].addEventListener('invalid', function() {
      this.setCustomValidity('Oups, votre demande est-elle bien complète ?');
    });
    // requiredFields[i].addEventListener('input', function() {
    // this.setCustomValidity('Oups, votre demande est-elle bien complète ?');
    // });
  }
}

function drawerOverlayFunctionality() {
  let triggerButtons = document.querySelectorAll('[data-open-drawer]');
  let closeDrawerTriggers = document.querySelectorAll('[data-close-drawer]');
  
  handleCardClick();
  handleCloseDrawerClick();
  
  
  function handleCardClick() {
    triggerButtons.forEach((button) => {
      button.addEventListener('click', () => { 
        let parentItem = button.closest('[data-card-item]');
        let drawer = parentItem?.querySelector('[data-drawer-overlay]')
        
        if (drawer == null || drawer == undefined) {
          drawer = document.querySelector('[data-drawer-overlay]');
        }
        drawer.style.display = "flex";
      })
    })
  }
  
  function handleCloseDrawerClick() { 
    closeDrawerTriggers.forEach((closeTrigger, closeTrigger_index) => {
      closeTrigger.addEventListener('click', () => {
        let drawer = closeTrigger.closest('[data-drawer-overlay]');
        
        drawer.style.display = "none";
      }) 
    })
  }
}

function initializeYotpo() {
  (function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="//staticw2.yotpo.com/HcFi2NqDISndOk9hQloiExQYiGDEwNacYuCqrnKY/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();
}

function hoverCardFunctionality() {
  const hoverCardTriggers = document.querySelectorAll('[data-hover-card-parent] a');
  const hoverCardBlocks = document.querySelectorAll('[data-hover-card-block]');
  
  hoverCardTriggers?.forEach((trigger, triggerIndex) => {
    hoverCardBlocks?.forEach((card, cardIndex) => {
      const hoverCardImage = card.querySelector('[data-hover-card-img]')?.getAttribute('data-hover-card-img');
      const hoverCardBtnText = card.querySelector('[data-hover-card-btn-text]')?.getAttribute('data-hover-card-btn-text');
      const hoverCardBtnLink = card.querySelector('[data-hover-card-btn-url]')?.getAttribute('data-hover-card-btn-url');
      
      if (triggerIndex === cardIndex) {
        tippy(trigger, {
          content: `<div class="shop-block-hover" style="background-image: url(${hoverCardImage});"><a class="button-white" style="text-decoration: none" href="${hoverCardBtnLink}" type="button">${hoverCardBtnText}</a></div>`,
          theme: 'tippy-image',
          allowHTML: true,
          interactive: true,
          interactiveBorder: 1,
          followCursor: true,
          arrow: false,
        });
      }
    });
  });
}

function gsapAccordion() {
  // begin gsap accordion
  let accordions = document.querySelectorAll("[data-accordion]");
  
  accordions.forEach((accordion) => {
    let items = Array.from(accordion.querySelectorAll('[data-accordion-item]'));
    let triggers = Array.from(accordion.querySelectorAll('[data-accordion-trigger]'));
    let triggerToggles = items.map(createAnimation);
    
    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => toggleMenu(trigger));
    });
    
    function toggleMenu(clickedMenu) {
      triggerToggles.forEach((toggleFn) => toggleFn(clickedMenu));
    }
    
    function createAnimation(element) {
      let trigger = element.querySelector("[data-accordion-trigger]");
      let item = trigger.closest("[data-accordion-item]");
      let content = element.querySelector("[data-accordion-content]");
      let icon = element.querySelector("[data-accordion-icon]");
      
      gsap.set(content, { height: "auto" });
      
      let animation = gsap
      .timeline({reversed: true})
      .from(content, {
        height: 0,
        duration: 0,
        ease: "power1.inOut"
      })
      .from(content, {
        paddingTop: 0,
        paddingBottom: 0,
        duration: 0,
        ease: "power1.inOut"
      }, "<")
      
      if (icon) {
        animation.to(icon, { duration: 0, rotation: 0, ease:"power2.inOut" }, 0)
      }
      
      return function (clickedMenu) {
        if (clickedMenu === trigger) {
          animation.reversed(!animation.reversed());
        } else {
          animation.reverse();
        }
      };
    }
  });
  // end gsap accordion
}

function scrollToFooterOnNewsletterSubscribe() {
  const currentURLPath = window.location.href;
  const footer = document.getElementById('shopify-section-footer-component');
  const footerForm = footer?.querySelector('form');
  const footerFormErrorElement = footerForm?.parentElement.querySelector('.w-form-fail');
  const customerExistsErrorMessage = 'Vous êtes déjà inscrit à cette liste.';
  
  if (currentURLPath.includes('/?customer_posted=true')) {
    scrollToFooter();
  } else if (currentURLPath.includes('/?contact%5Btags%5D=newsletter&form_type=customer#contact_form')) {
    footerFormErrorElement.style.display = "block";
    footerFormErrorElement.querySelector('div').textContent = customerExistsErrorMessage;
    scrollToFooter();
  }
  
  function scrollToFooter() {
    setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }, 200)
  }
}




const eshopHeader = document.querySelector("#eshop-header");
const eshopHeader2 = document.querySelector("#en-ce-moment");
const headerLinks = document.querySelectorAll("[data-menu-header]");

function mobileMenuAccordion() {
  $("[data-mobile-menu]").click(function (e) {
    const target = e.target;
    
    if (
      target.hasAttribute('data-menu-header')
      ) {
        const subItem = $(target).next();
        //slideUp all elements (except target) at current depth or greater
        const depth = $(subItem).parents().length;
        const allAtDepth = $("[data-mobile-menu] [data-accord-content]").filter(
          function () {
            if ($(this).parents().length >= depth && this !== subItem.get(0)) {
              return true;
            }
          }
          );
          $(allAtDepth).slideUp(10);
          
          //slideToggle target content and adjust bottom border if necessary
          subItem.slideToggle(10);
          
          resetAllHeaderLinks(target);
          
        }
      });
      openState();
      function openState() {
        setTimeout(() => {
          eshopHeader.click();
          eshopHeader2.click();
        }, 500)
      }
    }
    
    function resetAllHeaderLinks(targetElement) {
      const targetIsLevel2 = targetElement.hasAttribute('data-acc-level-2');
      const targetIsLevel1 = targetElement.hasAttribute('data-acc-level-1');
      
      headerLinks.forEach((headerLink) => {
        if (headerLink === targetElement) {
          headerLink.classList.toggle("is--open");
        } else if ((targetIsLevel2 && headerLink.hasAttribute('data-acc-level-2')) || targetIsLevel1) {
          headerLink.classList.remove("is--open");
        }
      });
    }
    
    
    function megaMenuMechanism() {
      const navBar = document.querySelector('[data-nav-component]');
      const megaMenusWrapper = navBar.querySelectorAll('[data-megamenus]');
      const triggers = document.querySelectorAll('[data-megamenu-trigger]');
      
      triggers.forEach(triggerElement => {
        const triggerID = triggerElement.dataset.megamenuTrigger;
        const megaMenuWrapper = triggerElement.querySelector('[data-megamenus]');
        const menuElement = megaMenuWrapper.querySelector(`[data-megamenu-menu]`);
        
        triggerElement.addEventListener('mouseover', () => {
          megaMenuWrapper.style.display = 'block';
          if (menuElement) {
            menuElement.style.display = 'flex';
          }
        });
        
        triggerElement.addEventListener('mouseout', (e) => {
          if (!megaMenuWrapper.contains(e.relatedTarget)) {
            megaMenuWrapper.style.display = 'none';
            if (menuElement) {
              menuElement.style.display = 'none';
            }
          }
        });
      });
    }
    
    
    function giftOrderCheckboxMechanism() {
      const giftCheckboxes = document.querySelectorAll('[data-order-notes="checkbox"]');
      const cartUpdateUrl = '/cart/update.js';
      
      // Reusable function to update the cart property
      const updateCartProperty = (isChecked) => {
        const attributes = isChecked ? { 'Cadeau': 'Oui' } : { 'Cadeau': '' };
        fetch(cartUpdateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ attributes: attributes })
        }).catch((error) => {
          console.error('Error:', error);
        });
      };
      
      // Function to handle checkbox change
      const handleCheckboxChange = (isChecked) => {
        updateCartProperty(isChecked);
        giftCheckboxes.forEach(cb => cb.checked = isChecked);
      };
      
      // Add event listeners to checkboxes
      giftCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', (event) => {
          handleCheckboxChange(event.target.checked);
        });
      });
      
      // Initial cart property check
      fetch(cartUpdateUrl, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(response => response.json())
      .then(data => {
        const hasGiftProperty = data.attributes && data.attributes.Cadeau === 'Oui';
        giftCheckboxes.forEach(cb => cb.checked = hasGiftProperty);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
    
    
    
    
    
    // #### development credits
    
    setTimeout(() => {
      console.warn("%cdevelopment by %cNFBS.studio%c", "border-radius: 20px; padding: 1px 4px; font-family: Helvetica,sans-serif; margin-right: 0px;", "background-color:#FFD601; color: #2F2700; border-radius: 20px; padding: 1px 4px; font-family: Helvetica,sans-serif;", "background-color: transparent; color: #2F2700; border-radius: 20px; padding: 1px 4px; font-family: Helvetica,sans-serif; text-decoration: underline;", "[ https://nfbs.studio ]");
    }, 2000)